import { defineMessages } from 'react-intl';

export const billingMessages = defineMessages({
    billingEntities: {
        id: 'billing-entities',
        defaultMessage: 'Billing entities',
    },
    billingEntity: {
        id: 'billing-entity',
        defaultMessage: 'Billing entity',
    },
    legalNumber: {
        id: 'legal-number',
        defaultMessage: 'UIC',
    },
    taxNumber: {
        id: 'tax-number',
        defaultMessage: 'Tax number',
    },
    editBillingEntitySubtitle: {
        id: 'edit-billing-entity-subtitle',
        defaultMessage: 'Edit billing entity {entity}',
    },
    updateBillingEntitySuccess: {
        id: 'update-billing-entity-success',
        defaultMessage: 'Billing entity updated',
    },
    updateBillingEntitySuccessDescription: {
        id: 'update-billing-entity-success-description',
        defaultMessage: 'Billing entity {entity} has been successfully updated.',
    },
    code: {
        id: 'code',
        defaultMessage: 'Code',
    },
    deleteBillingEntity: {
        id: 'delete-billing-entity',
        defaultMessage: 'Delete billing entity',
    },
    deleteBillingEntitySuccess: {
        id: 'delete-billing-entity-success',
        defaultMessage: 'Billing entity deleted',
    },
    deleteBillingEntitySuccessDescription: {
        id: 'delete-billing-entity-success-description',
        defaultMessage: 'The billing entity has been successfully deleted.',
    },
    confirmDeleteBillingEntity: {
        id: 'confirm-delete-billing-entity',
        defaultMessage: 'Are you sure you want to delete this billing entity? This action cannot be undone.',
    },
    deleteBillingEntitySubtitle: {
        id: 'delete-billing-entity-subtitle',
        defaultMessage: 'Permanently delete billing entity {entity}',
    },
    billingEntityDashboard: {
        id: 'billing-entity-dashboard',
        defaultMessage: 'Billing entity dashboard',
    },
    backToAllBillingEntities: {
        id: 'back-to-all-billing-entities',
        defaultMessage: 'Back to all billing entities',
    },
    legalName: {
        id: 'legal-name',
        defaultMessage: 'Legal name',
    },
    legalRepresentative: {
        id: 'legal-representative',
        defaultMessage: 'Legal representative',
    },
    tenantId: {
        id: 'tenant-id',
        defaultMessage: 'Tenant ID',
    },
    createBillingEntitySuccess: {
        id: 'create-billing-entity-success',
        defaultMessage: 'Billing entity created',
    },
    createBillingEntitySuccessDescription: {
        id: 'create-billing-entity-success-description',
        defaultMessage: 'Billing entity {entry} has been successfully created.',
    },
    addBillingEntitySubtitle: {
        id: 'add-billing-entity-subtitle',
        defaultMessage: 'Create a new billing-entity',
    },
    representative: {
        id: 'representative',
        defaultMessage: 'Representative',
    },
    invoicePrefix: {
        id: 'invoice-prefix',
        defaultMessage: 'Invoice prefix',
    },
    invoiceFooter: {
        id: 'invoice-footer',
        defaultMessage: 'Invoice footer',
    },
    bankAccounts: {
        id: 'bank-accounts',
        defaultMessage: 'Bank accounts',
    },
    billingSettings: {
        id: 'billing-settings',
        defaultMessage: 'Billing settings',
    },
    standardNoLogo: {
        id: 'standard-no-logo',
        defaultMessage: 'No logo',
    },
    standardLeftLogo: {
        id: 'standard-left-logo',
        defaultMessage: 'Logo on the left',
    },
    standardRightLogo: {
        id: 'standard-right-logo',
        defaultMessage: 'Logo on the right',
    },
    financialDocLogo: {
        id: 'financial-doc-logo',
        defaultMessage: 'Financial document logo',
    },
    financialDocColor: {
        id: 'financial-doc-color',
        defaultMessage: 'Financial document color',
    },
    financialDocPrintTemplate: {
        id: 'financial-doc-print-template',
        defaultMessage: 'Financial document print template',
    },
    clickToUpload: {
        id: 'click-to-upload',
        defaultMessage: 'Click to upload',
    },
    dragAndDrop: {
        id: 'drag-and-drop',
        defaultMessage: 'or drag and drop an image here',
    },
    searchBillingEntity: {
        id: 'search-billing-entity',
        defaultMessage: 'Search billing entity',
    },
    noBillingEntity: {
        id: 'no-billing-entity',
        defaultMessage: 'No billing entity',
    },
    noBillingEntityFound: {
        id: 'no-billing-entity-found',
        defaultMessage: 'No billing entity found',
    },
});
